class TemplatesView {
  constructor($el) {
    if (!$el.length) return
    this.$root = $el

    $el.find('.templates-card__make-default').on('click', this.handleMakeDefault)
    $el.find('.templates-card__source').select2().on('change', this.handleChangeSource)
  }

  handleMakeDefault() {
    const $form = $(this).closest('.templates-card')

    $form.find('.js-is-hero').val(true)

    $(document.body).css({ 'pointer-events': 'none', opacity: 0.7 })

    $form.submit()
  }

  handleChangeSource() {
    const $form = $(this).closest('.templates-card')
    $(document.body).css({ 'pointer-events': 'none', opacity: 0.7 })
    $form.submit()
  }
}

document.addEventListener('DOMContentLoaded', function () {
  return new TemplatesView($('.templates-view'))
})
